export default {
  forgot_password: {
    title: 'Passwort zurücksetzen',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Passwort vergessen',
    password_reset_text: 'Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten eine Bestätigungs-E-Mail, um Ihr Passwort zurückzusetzen.',
    submit: 'Senden',
    mail_address: 'E-Mail Adresse ausfüllen',
    input_label: '@:settings.user.email',
  },
}
